import { BlogArticlePage } from "@/components/blog/BlogArticlePage";
import type { BlogArticleView } from "@/utils/blog/types";

export interface PageProps {
  view: BlogArticleView;
}

export function Page({ view }: PageProps) {
  return <BlogArticlePage view={view} />;
}
